import React, {useEffect, useState} from "react";
import {getJsonValue, isBoolTrue} from "../../../common/fusion-ui/utils/ReactUtils";
import {Keys, Modules} from "../../config/AppConfig";
import {printError, printLog} from "../../utils/AppUtils";
import {AppInterface, HomeTabLayout} from "../../index";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {useTheme} from "../../../common/ProjectThemeProvider";
import {useConfig} from "../../context/ConfigProvider";

const DashboardPage = React.memo(({
                                      tabLayoutDefTab,
                                  }) => {
    const TAG = 'DashboardPage:';

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isConfigTrue, updateConfig} = useConfig();

    const Fields = {};
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        updateConfig(Keys.config_ShowTabBar, true);
        updateConfig(Keys.config_TabBarTab, Modules.Home);

        updateConfig(Keys.tracker_currPageModule, Modules.Home);
        updateConfig(Keys.tracker_currPageTag, TAG);

    }, []);

    return (<AppInterface>
        <HomeTabLayout defTab={tabLayoutDefTab}/>
    </AppInterface>);

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default DashboardPage;
